import { EditCampaignUrl } from "@common";
import {
    CampaignReviewForm,
    LoadingSpinner,
    ModalWindow,
    SvgBackground,
    TermsAndConditionsModal,
    Tour
} from "@components";
import {
    AppState,
    campaignCreativesForm,
    campaignMediaPlanForm,
    changeUpdateNavStateFlagAction,
    Country,
    generatePDFOfferAction,
    isReportingOnlyCustomer,
    MappingState,
    purchaseCampaignByIdAction
} from "@store";
import * as cn from "classnames";
import { History, Location } from "history";
import { FetchingState, FETCH_STATE_FETCHING, FETCH_STATE_INITIAL, FETCH_STATE_SUCCESS } from "rd-redux-http";
import * as React from "react";
import { connect, Dispatch } from "react-redux";
import { Prompt, RouteComponentProps } from "react-router";
import { CampaignAside } from "../components/CampaignAsideComponent";
import { CampaignCreativesPlanForm } from "../components/CampaignCreativesPlanForm";
import { CampaignMediaPlanForm } from "../components/CampaignMediaPlanForm";
import { AudiencesOff, AudiencesOn, CreativesOff, CreativesOn, MediaPlanOff, MediaPlanOn } from "../icons";
import { DefaultLayout } from "../layouts";
import "./Campaign.css";

export interface CampaignProps {
    history: History;
    location: Location;
    isEditCampaignPage: boolean;
    isSummaryCampaignPage: any;
    loading: boolean;
    loadingFailed: boolean;
    clientId: string;
    editCampaignId: string;
    isProcessing: boolean;
    countryList: Country[];
    isFullFirstPageCampaignForm: boolean;
    isFullSecondPageCampaignForm: boolean;
    campaignChangesFlag: boolean;
    isFirstBooking: boolean;
    updateNavStateFlag: boolean;
    pdfDowload: null | "LOADING" | "LOADED" | "ERROR";
    onPurchase?: (clientId: string, editCampaignId: string) => void;
    generatePDF?: (clientId: string, editCampaignId: string) => void;
    /**
     * https://adello.atlassian.net/browse/ACD-594
     * To disable page for fixed-price customers
     */
    disableContent: boolean;
    onChangeUpdateNavStateFlag?: (status: boolean) => void;
}

export interface CampaignComponentState {
    mediaPlanState: number;
    agreeStatus: boolean;
    isTermsAndConditionsModalOpen: boolean;
}

export class CampaignComponent extends React.Component<CampaignProps, CampaignComponentState> {
    constructor(props: CampaignProps) {
        super(props);
        this.state = {
            mediaPlanState: 0,
            agreeStatus: false,
            isTermsAndConditionsModalOpen: false
        };

        this.onChangeStatusTermsAndConditionsModal = this.onChangeStatusTermsAndConditionsModal.bind(this);
        this.onFocusTop = this.onFocusTop.bind(this);
    }

    private topOfForm = React.createRef<any>();
    private privacyAndPolicyLink = React.createRef<any>();

    componentDidUpdate() {
        if (this.props.updateNavStateFlag) {
            this.setState({
                mediaPlanState: 0
            });
            this.props.onChangeUpdateNavStateFlag(false);
        }
    }

    selectPlan(id: number): void {
        if (id >= 0 && id < 3)
            this.setState({
                mediaPlanState: id
            });
    }

    activateCheckpoint(id: number): string {
        if (id <= this.state.mediaPlanState) {
            return " active";
        }
        return "";
    }

    activateCheckpointBody(id: number): string {
        if (id === this.state.mediaPlanState) {
            return " active";
        }
        return "";
    }

    onFocusTop() {
        let node = this.topOfForm.current;

        if (node) {
            node.scrollIntoView({ block: "start", inline: "start" });
        }

        // do {
        //     node.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });
        //     node = node.parentElement;
        // } while (node);
    }

    onBack() {
        const mediaPlanState = this.state.mediaPlanState;

        if (mediaPlanState > 0) {
            this.setState({
                ...this.state,
                mediaPlanState: mediaPlanState - 1
            });
        }

        this.onFocusTop();
    }

    onNext() {
        const mediaPlanState = this.state.mediaPlanState;
        this.setState({
            ...this.state,
            mediaPlanState: mediaPlanState + 1
        });

        this.onFocusTop();
    }

    changeAgreeStatus(status: boolean) {
        this.setState({
            ...this.state,
            agreeStatus: status,
            isTermsAndConditionsModalOpen: false
        });
    }

    onChangeStatusTermsAndConditionsModal(isOpen: boolean) {
        this.setState({
            ...this.state,
            isTermsAndConditionsModalOpen: isOpen
        });
    }

    handleShowTermsAndCondotions(e: any) {
        e.preventDefault();
        e.stopPropagation();
        this.onChangeStatusTermsAndConditionsModal(true);
    }

    campaignSummaryChecker(selectedOption: boolean) {
        if (selectedOption) {
            this.selectPlan(2);
        }
    }

    renderAside(): React.ReactChild {
        return (
            <>
                <CampaignAside
                    clientId={this.props.clientId}
                    history={this.props.history}
                    location={this.props.location}
                    displayAsSummary={this.props.isSummaryCampaignPage}
                    isError={this.props.loadingFailed}
                />
            </>
        );
    }

    render() {
        const { mediaPlanState, isTermsAndConditionsModalOpen } = this.state;
        const {
            isEditCampaignPage,
            isSummaryCampaignPage,
            loading,
            clientId,
            history,
            location,
            isProcessing,
            countryList,
            editCampaignId,
            onPurchase,
            isFullFirstPageCampaignForm,
            isFullSecondPageCampaignForm,
            isFirstBooking,
            loadingFailed,
            campaignChangesFlag,
            pdfDowload,
            disableContent,
            generatePDF
        } = this.props;

        return (
            <DefaultLayout
                isEditCampaignPage={isEditCampaignPage}
                asideChildren={() => this.renderAside()}
                selectedPage="campaign"
                loading={loading}
                loadingFailed={loadingFailed}
                clientId={clientId}
                history={history}
                location={location}
                disableContent={disableContent}
            >
                <Prompt
                    when={campaignChangesFlag && !isSummaryCampaignPage}
                    message={location => `Do you want to leave without saving? All unsaved data will be lost`}
                />
                <Tour
                    tour={
                        mediaPlanState === 0
                            ? "campaign-media-plan"
                            : mediaPlanState === 1
                                ? "campaign-creatives"
                                : "campaign-media-plan"
                    }
                    isRunning={!loading && !loadingFailed}
                />
                <div
                    className={cn("form-wrapper", isProcessing ? "isProcessing" : "")}
                    onLoad={_ => this.campaignSummaryChecker(isSummaryCampaignPage)}
                >
                    <section className={cn("media-plan")}>
                        <h2 className="campaign-header__title tour-campaign-title">
                            <span className="campaign-header__main-title" ref={this.topOfForm}>
                                {!isEditCampaignPage && !isSummaryCampaignPage
                                    ? "Create Campaign"
                                    : isEditCampaignPage
                                        ? "Edit Campaign"
                                        : undefined}
                            </span>
                            <span className="campaign-header__subtitle">
                                {mediaPlanState === 0 && !isSummaryCampaignPage
                                    ? "Media plan"
                                    : mediaPlanState === 1
                                        ? "Creatives"
                                        : mediaPlanState === 2 && !isSummaryCampaignPage
                                            ? "Review"
                                            : undefined}
                            </span>

                            <span className="campaign-header__main-title" ref={this.topOfForm}>
                                {isSummaryCampaignPage ? "Campaign Summary" : undefined}
                            </span>
                        </h2>

                        <div
                            className={cn(
                                "campaign-nav tour-campaign-tabs",
                                isSummaryCampaignPage ? "campaign-nav__hidden" : ""
                            )}
                        >
                            <ul className="campaign-nav-list">
                                <li
                                    className={cn("campaign-nav-list-item", mediaPlanState === 0 ? "active" : "")}
                                    onClick={e => this.selectPlan(0)}
                                >
                                    <span className="checkpoint-text">Media plan</span>
                                    <SvgBackground
                                        className="mediaPlan-nav-icon mediaPlanBadSVG"
                                        svg={mediaPlanState === 0 ? MediaPlanOn : MediaPlanOff}
                                    />
                                </li>
                                <li
                                    className={cn(
                                        "campaign-nav-list-item tour-campaign-creatives-tab",
                                        !isFullFirstPageCampaignForm ? "disabled-nav-list-item" : "",
                                        mediaPlanState === 1 ? "active" : ""
                                    )}
                                    onClick={e => (isFullFirstPageCampaignForm ? this.selectPlan(1) : "")}
                                >
                                    <span className="checkpoint-text">Creatives</span>
                                    <SvgBackground
                                        className="mediaPlan-nav-icon"
                                        svg={mediaPlanState === 1 ? CreativesOn : CreativesOff}
                                    />
                                </li>
                                <li
                                    className={cn(
                                        "campaign-nav-list-item tour-campaign-review-tab",
                                        !isFullSecondPageCampaignForm ? "disabled-nav-list-item" : "",
                                        mediaPlanState === 2 ? "active" : ""
                                    )}
                                    onClick={e => (isFullSecondPageCampaignForm ? this.selectPlan(2) : "")}
                                >
                                    <span className="checkpoint-text">Review</span>
                                    <SvgBackground
                                        className="mediaPlan-nav-icon"
                                        svg={mediaPlanState === 2 ? AudiencesOn : AudiencesOff}
                                    />
                                </li>
                            </ul>
                        </div>
                    </section>
                    <section className={"checkpoint-body checkpoint-body-1 accordion" + this.activateCheckpointBody(0)}>
                        {mediaPlanState === 0 && <CampaignMediaPlanForm countryList={countryList} />}
                    </section>
                    <section className={"checkpoint-body checkpoint-body-2 accordion" + this.activateCheckpointBody(1)}>
                        {mediaPlanState === 1 && <CampaignCreativesPlanForm />}
                    </section>
                    <section className={"checkpoint-body checkpoint-body-3 accordion" + this.activateCheckpointBody(2)}>
                        {mediaPlanState === 2 && <CampaignReviewForm countryList={countryList} />}
                    </section>
                    {mediaPlanState === 2 &&
                        !isSummaryCampaignPage && (
                            <div className="agree-msg">
                                <ModalWindow
                                    modalId="TermsAndConditionsModal"
                                    state={isTermsAndConditionsModalOpen}
                                    transition={true}
                                >
                                    <TermsAndConditionsModal
                                        onCancel={() => this.onChangeStatusTermsAndConditionsModal(false)}
                                        onAccept={(status: boolean) => this.changeAgreeStatus(status)}
                                    />
                                </ModalWindow>
                                <p
                                    className="agree-msg_text"
                                    onClick={(e: any) =>
                                        isFirstBooking
                                            ? this.onChangeStatusTermsAndConditionsModal(true)
                                            : e.target !== this.privacyAndPolicyLink.current &&
                                              this.changeAgreeStatus(!this.state.agreeStatus)
                                    }
                                >
                                    <span className={cn("agree-msg_btn", this.state.agreeStatus ? "active" : "")} />I
                                    agree to the{" "}
                                    <span
                                        className="agree-msg_conditionals"
                                        onClick={e => this.handleShowTermsAndCondotions(e)}
                                    >
                                        &nbsp; Terms &amp; Conditions &nbsp;
                                    </span>{" "}
                                    and the
                                    <a
                                        href="https://www.adello.com/about-us/privacy-policy/"
                                        ref={this.privacyAndPolicyLink}
                                        target="_blank"
                                        className="agree-msg_policy"
                                    >
                                        &nbsp;Privacy Policy
                                    </a>.
                                </p>
                            </div>
                        )}
                    <div
                        className={cn(
                            "form-control-btn-wrapper",
                            isSummaryCampaignPage ? "form-control-btn-wrapper__hidden" : ""
                        )}
                    >
                        <button
                            className={cn(
                                "common-btn custom-form-control-btn",
                                mediaPlanState < 1 ? "disabled-form-control-btn" : ""
                            )}
                            type="button"
                            onClick={() => this.onBack()}
                            disabled={mediaPlanState < 1 ? true : false}
                        >
                            Back
                        </button>
                        {mediaPlanState === 2 ? (
                            <button
                                className={cn(
                                    "common-btn custom-form-control-btn custom-purchase-btn tour-campaign-purchase-button",
                                    this.state.agreeStatus ? "" : "disabled"
                                )}
                                type="button"
                                onClick={e => onPurchase(clientId, editCampaignId)}
                                disabled={!this.state.agreeStatus}
                            >
                                Purchase campaign
                            </button>
                        ) : (
                            <button
                                className={cn(
                                    "common-btn custom-form-control-btn next-btn tour-campaign-next-button",
                                    mediaPlanState === 0 ? "next-btn-with-hint" : "",
                                    (!isFullFirstPageCampaignForm && mediaPlanState === 0) ||
                                    (!isFullSecondPageCampaignForm && mediaPlanState === 1)
                                        ? "disabled-form-control-btn"
                                        : ""
                                )}
                                type="button"
                                onClick={() =>
                                    (isFullFirstPageCampaignForm && mediaPlanState === 0) ||
                                    (isFullSecondPageCampaignForm && mediaPlanState === 1)
                                        ? this.onNext()
                                        : ""
                                }
                            >
                                Next
                            </button>
                        )}
                        <div
                            className={cn(
                                "generate-pdf-offer-wrapper",
                                mediaPlanState === 2 ? "" : "generate-pdf-offer-wrapper--hidden"
                            )}
                        >
                            {pdfDowload !== "LOADING" ? (
                                <button
                                    className="common-btn custom-form-control-btn custom-pdf-btn tour-campaign-generate-pdf-offer"
                                    onClick={e => generatePDF(clientId, editCampaignId)}
                                >
                                    Generate Offer (pdf)
                                </button>
                            ) : (
                                <span className="spinner">
                                    <LoadingSpinner />
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            </DefaultLayout>
        );
    }
}

export interface CampaignPageProps extends RouteComponentProps<{}> {}

export const CampaignPage = connect(
    (state: AppState, ownProps: CampaignPageProps): Partial<CampaignProps> => {
        const onlyReporting = isReportingOnlyCustomer(state);
        const matchEditCampaignPage = EditCampaignUrl.match(ownProps.history.location.pathname, true);

        const isSummaryCampaignPage = checkSummaryCampaignPage(state, matchEditCampaignPage);
        const isEditCampaignPage = checkEditCampaignPage(state, matchEditCampaignPage);

        const mappings = state.mappings;
        const isMappingsLoading: boolean = checkMappingsLoading(mappings);
        const isMappingsFailed: boolean = checkMappingsFailed(mappings);

        const campaignMediaPlanFormSelectionResult = campaignMediaPlanForm.selector(
            state.campaignState.campaignMediaPlanForm
        );
        const campaignCreativesFormSelectionResult = campaignCreativesForm.selector(
            state.campaignState.campaignCreativesForm
        );

        const timetable = findTimetable(campaignMediaPlanFormSelectionResult.fields.timetable.value);

        const editCampaignId =
            state.campaignState.editingCampaign.fetchState === FETCH_STATE_SUCCESS
                ? state.campaignState.editingCampaign.data.result.campaignId
                : undefined;

        const campaignIdFromUrl = matchEditCampaignPage.isMatched ? matchEditCampaignPage.params.campaignId : undefined;

        let isExistingCampaign: boolean = true;

        if (!editCampaignId && campaignIdFromUrl !== "new" && FetchingState.isSuccess(state.campaignList.campaigns)) {
            isExistingCampaign = state.campaignList.campaigns.data.find(c => c.campaignId === campaignIdFromUrl)
                ? true
                : false;
        }

        const loading: boolean = checkLoading(state, isEditCampaignPage, isExistingCampaign, isMappingsLoading);
        const loadingFailed: boolean = checkLoadingFailed(
            state,
            isEditCampaignPage,
            isExistingCampaign,
            isMappingsFailed,
            loading
        );

        const clientId: string = matchEditCampaignPage.isMatched && matchEditCampaignPage.params.clientId;

        const isFullFirstPageCampaignForm: boolean = checkFullFirstPageCampaignForm(
            campaignMediaPlanFormSelectionResult,
            timetable
        );

        const isFullSecondPageCampaignForm: boolean =
            campaignCreativesFormSelectionResult.fields.adUnitType.value &&
            campaignCreativesFormSelectionResult.fields.adUnitId.value;

        const isFirstBooking: boolean = checkFirstBooking(state, isSummaryCampaignPage);

        return {
            history: ownProps.history,
            location: ownProps.history.location,
            countryList: (state.campaignState.countryList || []).filter(c => c.canCreateCampaign),
            isEditCampaignPage,
            isSummaryCampaignPage,
            editCampaignId,
            loading,
            loadingFailed,
            clientId,
            isProcessing: state.campaignState.isSaveOrPurchaseProcessing,
            isFullFirstPageCampaignForm,
            isFullSecondPageCampaignForm,
            isFirstBooking,
            campaignChangesFlag: state.campaignState.campaignChangesFlag,
            updateNavStateFlag: state.campaignState.updateNavStateFlag,
            pdfDowload: state.campaignState.generatePdfOffer,
            disableContent: onlyReporting
        };
    },
    (dispatch: Dispatch) => ({
        onPurchase: (clientId: string, editCampaignId: string) => {
            dispatch(purchaseCampaignByIdAction({ clientId: clientId, campaignId: editCampaignId }));
        },
        onChangeUpdateNavStateFlag: (status: boolean) => {
            dispatch(changeUpdateNavStateFlagAction({ status: status }));
        },
        generatePDF(clientId: string, editCampaignId: string) {
            dispatch(generatePDFOfferAction({ clientId: clientId, campaignId: editCampaignId }));
        }
    })
)(CampaignComponent);

function checkSummaryCampaignPage(state: AppState, matchEditCampaignPage: any) {
    const isSummaryCampaignPage: boolean =
        state.campaignState.editingCampaign.fetchState === FETCH_STATE_INITIAL &&
        state.campaignState.summaryCampaign.fetchState === FETCH_STATE_SUCCESS &&
        matchEditCampaignPage.isMatched &&
        matchEditCampaignPage.params.campaignId !== "new";

    return isSummaryCampaignPage;
}

function checkEditCampaignPage(state: AppState, matchEditCampaignPage: any) {
    const isEditCampaignPage: boolean =
        state.campaignState.summaryCampaign.fetchState === FETCH_STATE_INITIAL &&
        matchEditCampaignPage.isMatched &&
        matchEditCampaignPage.params["campaignId"] !== "new";

    return isEditCampaignPage;
}

function checkMappingsLoading(mappings: MappingState) {
    const isMappingsLoading: boolean =
        FetchingState.isInitialOrFetching(mappings.adunits) ||
        FetchingState.isInitialOrFetching(mappings.age) ||
        FetchingState.isInitialOrFetching(mappings.currencies) ||
        FetchingState.isInitialOrFetching(mappings.devices) ||
        FetchingState.isInitialOrFetching(mappings.gender) ||
        FetchingState.isInitialOrFetching(mappings.interests) ||
        FetchingState.isInitialOrFetching(mappings.languages);

    return isMappingsLoading;
}

function checkMappingsFailed(mappings: MappingState) {
    const isMappingsFailed: boolean =
        FetchingState.isError(mappings.adunits) ||
        FetchingState.isError(mappings.age) ||
        FetchingState.isError(mappings.currencies) ||
        FetchingState.isError(mappings.devices) ||
        FetchingState.isError(mappings.gender) ||
        FetchingState.isError(mappings.interests) ||
        FetchingState.isError(mappings.languages);

    return isMappingsFailed;
}

const datesMap = {
    Sun: "Sunday",
    Mon: "Monday",
    Tue: "Tuesday",
    Wed: "Wednesday",
    Thu: "Thursday",
    Fri: "Friday",
    Sat: "Saturday"
};

function findTimetable(data: any) {
    const timetable = data
        ? Object.keys(data)
              .map((tableKey: string, index: number) => {
                  const table = data[tableKey];
                  const tableKeys = Object.keys(table);
                  const selectedTableKeys = tableKeys.filter(key => table[key]);
                  return {
                      key: datesMap[tableKey],
                      allDay: selectedTableKeys.length == tableKeys.length,
                      selectedKeys: selectedTableKeys
                  };
              })
              .filter(table => table.allDay || table.selectedKeys.length)
        : undefined;

    return timetable;
}

function checkLoading(
    state: AppState,
    isEditCampaignPage: boolean,
    isExistingCampaign: boolean,
    isMappingsLoading: boolean
) {
    const loading: boolean =
        state.campaignState.summaryCampaign.fetchState === FETCH_STATE_FETCHING ||
        state.campaignState.editingCampaign.fetchState === FETCH_STATE_FETCHING ||
        (isEditCampaignPage &&
            state.campaignState.editingCampaign.fetchState === FETCH_STATE_INITIAL &&
            isExistingCampaign) ||
        isMappingsLoading ||
        state.campaignState.isSaveOrPurchaseProcessing ||
        state.campaignState.isRequiredDataLoading ||
        state.clientState.clientSavingFlag;
    return loading;
}

function checkLoadingFailed(
    state: AppState,
    isEditCampaignPage: boolean,
    isExistingCampaign: boolean,
    isMappingsFailed: boolean,
    loading: boolean
) {
    const loadingFailed: boolean =
        FetchingState.isError(state.campaignState.summaryCampaign) ||
        FetchingState.isError(state.campaignState.editingCampaign) ||
        (isEditCampaignPage && FetchingState.isError(state.campaignState.editingCampaign)) ||
        isMappingsFailed ||
        (!loading && isEditCampaignPage && !isExistingCampaign);
    return loadingFailed;
}

function checkFullFirstPageCampaignForm(campaignMediaPlanFormSelectionResult: any, timetable: any) {
    const isFullFirstPageCampaignForm: boolean =
        campaignMediaPlanFormSelectionResult.isValid === true &&
        campaignMediaPlanFormSelectionResult.fields.language.value &&
        campaignMediaPlanFormSelectionResult.fields.country.value &&
        (campaignMediaPlanFormSelectionResult.fields.priceModel.value === "CPC" || (timetable && timetable.length > 0));

    return isFullFirstPageCampaignForm;
}

function checkFirstBooking(state: AppState, isSummaryCampaignPage: boolean) {
    const isFirstBooking: boolean =
        FetchingState.isSuccess(state.campaignList.campaigns) &&
        !isSummaryCampaignPage &&
        state.campaignList.campaigns.data.filter(c => c.status !== "draft" && c.status !== "pending").length > 0
            ? false
            : true;
    return isFirstBooking;
}
